<template>
  <!-- START NAV -->
  <div v-if="$root.showHeader">
    <nav
      class="navbar"
      role="navigation"
    >
      <div class="container">
        <div class="navbar-brand">
          <router-link
            v-if="$root.goBackLink === null"
            class="navbar-item navbar-logo"
            to="/admin"
          >
            Self Storage Solution
          </router-link>
          <a
            v-else
            class="navbar-item"
            title="Go back"
            style="transform: rotate(180deg); font-size: 1.5em"
            @click="$router.push({name:$root.goBackLink})"
          >&#10140;</a>

          <a
            ref="navMenuButton"
            role="button"
            aria-label="menu"
            aria-expanded="false"
            class="navbar-burger burger"
            data-target="navMenu"
            @click="showMenu"
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </a>
        </div>
        <div
          id="navMenu"
          ref="navMenu"
          class="navbar-menu"
        >
          <div
            v-if="$root.showNavigation"
            class="navbar-start"
          >
            <router-link
              to="/admin"
              class="navbar-item"
              :class="[currentPage == '/admin' ? 'is-active' : '']"
              @click.native="hideMenu()"
            >
              <span>News</span>
            </router-link>
            <router-link
              to="/admin/workflow"
              class="navbar-item"
              :class="[(currentPage.includes('admin/workflow')) ? 'is-active' : '']"
              @click.native="hideMenu()"
            >
              <span>Workflow</span>
            </router-link>
            <router-link
              to="/admin/user"
              class="navbar-item"
              :class="[(currentPage == '/admin/user') ? 'is-active' : '']"
              @click.native="hideMenu()"
            >
              <span>User</span>
            </router-link>
            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link">
                Accounts
              </a>
              <div class="navbar-dropdown is-right">
                <router-link
                  to="/admin/accounts/user"
                  class="navbar-item"
                  @click.native="hideMenu()"
                >
                  User
                </router-link>
                <router-link
                  to="/admin/accounts/company"
                  class="navbar-item"
                  @click.native="hideMenu()"
                >
                  Company
                </router-link>
              </div>
            </div>
          </div>
          <div
            v-else
            class="navbar-start"
          />

          <div class="navbar-end">
            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link is-hidden-touch">
                {{ $store.state.user.firstname }} {{ $store.state.user.lastname }}
              </a>

              <div class="navbar-dropdown is-right">
                <hr class="navbar-divider is-hidden-desktop">
                <router-link
                  to="/user/profile"
                  class="navbar-item"
                  @click.native="hideMenu()"
                >
                  <i class="fas fa-user fa-fw" /> My profile
                </router-link>
                <a
                  href="#"
                  class="navbar-item logout"
                  @click="logout"
                >
                  <i class="fas fa-power-off fa-fw" /> Logout
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
  <!-- END NAV -->
</template>

<script>
export default {
  name: 'AdminHeaderComponent',
  computed: {
    currentPage() {
      return this.$route.path;
    }
  },
  mounted() {
    // Perform JS for the component here

  },
  methods: {
    logout(e) {
      e.preventDefault();
      const self = this;
      this.$store.dispatch('logout', () => { self.$router.push({ name: 'login' }); });
    },
    showMenu(e) {
      e.preventDefault();
      const target = document.querySelector(`#${e.currentTarget.dataset.target}`);
      e.currentTarget.classList.toggle('is-active');
      target.classList.toggle('is-active');
    },
    hideMenu() {
      const menu = this.$refs.navMenu;
      const button = this.$refs.navMenuButton;

      if (menu.classList.contains('is-active')) {
        menu.classList.remove('is-active');
      }

      if (button.classList.contains('is-active')) {
        button.classList.remove('is-active');
      }
    }
  }
};
</script>

<style scoped>
    .navbar-item i.fas {
        margin-right: 10px;
    }

    @media screen and (max-width: 1024px){
        .navbar-company .navbar-link {
            pointer-events: none;
        }

        .navbar-company .navbar-link:after {
            display: none;
        }
    }
</style>
